
import { mapState } from 'vuex'

export default {
  props: {
    item: { type: Object, required: true },
    header: { type: Object, required: true },
    lineHeight: { type: Number, required: true },
    filters: { type: Array, required: true },
    truncate: { type: Number, required: true },
    dense: { type: Boolean, default: false },
    noInteraction: { type: Boolean, default: false }
  },
  data: () => ({
    showMapPreview: false
  }),
  computed: {
    ...mapState(['env'])
  }
}
